/* eslint-disable max-len */
import ApplicationStore from '../utils/localStorageUtil';

const _fetchServiceDownloadCsvData = (PATH, serviceMethod, data, successCallback, errorCallBack, fileName, reportType) => {
  const { user_token, userDetails } = ApplicationStore().getStorage('userDetails');
  // const END_POINT = 'https://ai.wisething.in/yenepoya/api/';
  // const END_POINT = 'https://varmatrix.com/YENEPOYA_2025/api/';
  const END_POINT = ' https://insightsx.in/SahyadriHostel/api/';
  // const END_POINT = 'https://insightsx.in/yenepoya_blr/api/';




  const { emailId, userRole, companyCode } = userDetails;
 
  const headers = {
    'Content-Type': 'blob',
    authorization: `Bearer ${user_token}`,
    // companyCode: `${companyCode}`,
    // userId: `${emailId}`,
    // userRole: `${userRole}`,
    responseType: 'arraybuffer',
    userRole: `${userRole}`,
    branch:`${userDetails.branch}`,
    location:`${userDetails.location}`,
    email:`${userDetails.email}`,
  };

  const body = (serviceMethod === 'GET') || (serviceMethod === 'DELETE') ? {} : { body: JSON.stringify(data) };

  const bodyParameters = {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    headers,
    ...body,
  };

  const bodyObject = {
    method: serviceMethod,
    ...bodyParameters,
  };

  let filename = '';

  return fetch(END_POINT + PATH, bodyObject)
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }

      // const contentDisposition = response.headers.get('Content-Disposition');
      // filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
      filename = fileName || 'Reports.xlsx';
      // var filename = `${Date.now()}.xlsx`; //contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
      if(reportType === 'download'){
        return response.blob();
      } else if(reportType === 'email'){
        return response.json();
      }
    })
    .then((dataResponse) => {
      successCallback(dataResponse);
      if(reportType === 'download'){
        if (dataResponse != null) {
          const url = window.URL.createObjectURL(dataResponse);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          // a.remove();
        }
      } else if(reportType === 'email'){
        //
      }
    })
    .catch((error) => {
      error.errorObject.then((errorResponse) => {
        if (error.errorStatus === 401 && errorResponse.message === 'Unable to access the page, Token Expired') {
          ApplicationStore().clearStorage();
          /* eslint-disable-next-line */
          location.reload();
        }
        errorCallBack(error.errorStatus, errorResponse.message);
      });
    });
};

export const DownloadFacultyTemplate = (successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData('faculty/template', 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const DownloadAttendanceTemplate = (successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData('attendence/getTemp', 'GET', {}, successCallback, errorCallBack, '', 'download');
};


export const DownloadStudentTemplate = (successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData('student/template', 'GET', {}, successCallback, errorCallBack, '', 'download');
};

// export const DownloadStudentReport = (data, successCallback, errorCallBack) => {
//   return _fetchServiceDownloadCsvData(`report/getAttendanceReport/download/${data.yearMonth}/${data.location}/${data.branch}/${data.specialization}/${data.semester}/${data.section}/${data.subject}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
// };

  export const DownloadStudentReport = (data, successCallback, errorCallBack) => {

  const finalLocation = data.location || data.headerLocation;
  

  return _fetchServiceDownloadCsvData(
    `report/getAttendanceReport/download/${data.yearMonth}/${finalLocation}/${data.branch}/${data.specialization}/${data.semester}`,
    'GET',
    {},
    successCallback,
    errorCallBack,
    '',
    'download'
  );
};


export const DownloadStudentTransferReport = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`student/beforeTransfer/download?location=${data.location}&branch=${data.branch}&specialization=${data.specialization}&semester=${data.semester}&section=${data.section}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const DownloadStudentSemWiseReport = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`getSemWiseExport/${data.monthFrom}/${data.monthTo}?location=${data.location}&branch=${data.branch}&specialization=${data.specialization}&semester=${data.semester}&section=${data.section}&subject=${data.subject}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const DownloadStudentWiseReport = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`studentAttendanceEcport?monthFrom=${data.monthFrom}&monthTo=${data.monthTo}&location=${data.location}&branch=${data.branch}&specialization=${data.specialization}&semester=${data.semester}&section=${data.section}&studentId=${data.studentId}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const DownloadFacultyReport = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`report/facultyReport/download/${data.yearMonth}/${data.location}/${data.branch}/${data.specialization}/${data.semester}/${data.section}/${data.facultyId}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const DownloadConsolidatedReport = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`report/DayWiseAttendanceAllSubjectExport/download/${data.fromDate}/${data.toDate}/${data.location}/${data.branch}/${data.specialization}/${data.semester}/${data.section}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const DownloadUserTemplate = (successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData('user/template', 'GET', {}, successCallback, errorCallBack, '', 'download');
};











































export const DownloadReportAlarmCsv = (data, successCallback, errorCallBack) => {
  const { location_id, branch_id, facility_id, building_id, floor_id, lab_id, deviceId, fromDate, toDate } = data;
  return _fetchServiceDownloadCsvData(`exportAlarm?=&location_id=${location_id}&branch_id=${branch_id}&facility_id=${facility_id}&building_id=${building_id}&floor_id=${floor_id}&lab_id=${lab_id}&deviceId=${deviceId}&fromDate=${fromDate}&toDate=${toDate}`, 'GET', {}, successCallback, errorCallBack, 'Alarms Report.xlsx', 'download');
};

export const DownloadReportBumpTestCsv = (data, successCallback, errorCallBack) => {
  const { location_id, branch_id, facility_id, building_id, floor_id, lab_id, device_id, fromDate, toDate} = data;
  return _fetchServiceDownloadCsvData(`exportBumpTestCsv?=&location_id=${location_id}&branch_id=${branch_id}&facility_id=${facility_id}&building_id=${building_id}&floor_id=${floor_id}&lab_id=${lab_id}&deviceId=${device_id}&fromDate=${fromDate}&toDate=${toDate}`, 'GET', {}, successCallback, errorCallBack, 'Bump Test Report.xlsx', 'download');
};

export const DownloadReportAqiStatusCsv = (data, successCallback, errorCallBack) => {
  // const deviceId = data.device_id;
  const { location_id } = data;
  const { branch_id } = data;
  const { facility_id } = data;
  const { building_id } = data;
  const { floor_id } = data;
  const { lab_id } = data;
  return _fetchServiceDownloadCsvData(`exportAqiStatusReport?=&location_id=${location_id}&branch_id=${branch_id}&facility_id=${facility_id}&building_id=${building_id}&floor_id=${floor_id}&lab_id=${lab_id}`, 'GET', {}, successCallback, errorCallBack);
};

export const DownloadReportSensorLogCsv = (data, successCallback, errorCallBack) => {
  const { location_id, branch_id, facility_id, building_id, floor_id, lab_id, deviceId, fromDate, toDate } = data;
  return _fetchServiceDownloadCsvData(`exportSensorLogCsv?=&location_id=${location_id}&branch_id=${branch_id}&facility_id=${facility_id}&building_id=${building_id}&floor_id=${floor_id}&lab_id=${lab_id}&deviceId=${deviceId}&fromDate=${fromDate}&toDate=${toDate}`, 'GET', {}, successCallback, errorCallBack, 'Device Logs Report.xlsx', 'download');
};

export const DownloadReportAqiCsv = (data, successCallback, errorCallBack) => {
  const { location_id, branch_id, facility_id, building_id, floor_id, lab_id, fromDate, toDate, deviceId} = data;
  return _fetchServiceDownloadCsvData(`aqiReportExport?location_id=${location_id}&branch_id=${branch_id}&facility_id=${facility_id}&building_id=${building_id}&floor_id=${floor_id}&lab_id=${lab_id}&deviceId=${deviceId}&fromDate=${fromDate}&toDate=${toDate}`, 'GET', {}, successCallback, errorCallBack, 'AQI Report.xlsx', 'download');
};

export const serverUtiliExport = (data, successCallback, errorCallBack) => {
  const { fromDate } = data;
  const { toDate } = data;
  return _fetchServiceDownloadCsvData(`serverUtiliExport?=&fromDate=${fromDate}&toDate=${toDate}`, 'GET', {}, successCallback, errorCallBack, 'Server Utilization Report.xlsx', 'download');
};

export const DownloadAppVersionReport = (successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`appVersionExport`, 'GET', {}, successCallback, errorCallBack, 'Application Version Report.xlsx', 'download');
};

export const DownloadFirmwareVersionReport = (data, successCallback, errorCallBack) => {
  const { location_id, branch_id, facility_id, building_id, floor_id, lab_id, deviceId} = data;
  return _fetchServiceDownloadCsvData(`firmwareExport?&location_id=${location_id}&branch_id=${branch_id}&facility_id=${facility_id}&building_id=${building_id}&floor_id=${floor_id}&lab_id=${lab_id}&deviceId=${deviceId}`, 'GET', {}, successCallback, errorCallBack, 'Firmware Version Report.xlsx', 'download');
};

export const DownloadHardwareVersionReport = (data, successCallback, errorCallBack) => {
  const { location_id, branch_id, facility_id, building_id, floor_id, lab_id, deviceId} = data;
  return _fetchServiceDownloadCsvData(`exportHardwareVersionLogs?&location_id=${location_id}&branch_id=${branch_id}&facility_id=${facility_id}&building_id=${building_id}&floor_id=${floor_id}&lab_id=${lab_id}&deviceId=${deviceId}`, 'GET', {}, successCallback, errorCallBack, 'Hardware Model Version Report.xlsx', 'download');
};

export const DownloadSensorStatusCsv = (data, successCallback, errorCallBack) => {
  const { location_id, branch_id, facility_id, building_id, floor_id, lab_id, deviceId, fromDate, toDate} = data;
  return _fetchServiceDownloadCsvData(`sensorStatusReportExport?&location_id=${location_id}&branch_id=${branch_id}&facility_id=${facility_id}&building_id=${building_id}&floor_id=${floor_id}&lab_id=${lab_id}&deviceId=${deviceId}&fromDate=${fromDate}&toDate=${toDate}`, 'GET', {}, successCallback, errorCallBack, 'Sensor Status Report.xlsx', 'download');
};

// -----------------------------------------//
// ---------------  Email ------------------//
// -----------------------------------------//

// ---------------- Alarm Email ---------------- //

export const EmailAlarmReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`alarmReportMailExcelFile?location_id=${data.location_id}&deviceId=${data.deviceId}&fromDate=${data.fromDate}&toDate=${data.toDate}&branch_id=${data.branch_id}&facility_id=${data.facility_id}&building_id=${data.building_id}&floor_id=${data.floor_id}&lab_id=${data.lab_id}`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

// ---------------- AQI Index Email ---------------- //

export const EmailAQIIndexReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`aqiReportMailExcelFile?location_id=${data.location_id}&deviceId=${data.deviceId}&fromDate=${data.fromDate}&toDate=${data.toDate}&branch_id=${data.branch_id}&facility_id=${data.facility_id}&building_id=${data.building_id}&floor_id=${data.floor_id}&lab_id=${data.lab_id}`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

// ---------------- AQI Index Email ---------------- //

export const EmailSensorStatusReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`emailSensorStatusReport?location_id=${data.location_id}&deviceId=${data.deviceId}&fromDate=${data.fromDate}&toDate=${data.toDate}&branch_id=${data.branch_id}&facility_id=${data.facility_id}&building_id=${data.building_id}&floor_id=${data.floor_id}&lab_id=${data.lab_id}`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

// ---------------- Device Log Email ---------------- //

export const EmailDeviceLogReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`emailDeviceLog?location_id=${data.location_id}&deviceId=${data.deviceId}&fromDate=${data.fromDate}&toDate=${data.toDate}&branch_id=${data.branch_id}&facility_id=${data.facility_id}&building_id=${data.building_id}&floor_id=${data.floor_id}&lab_id=${data.lab_id}`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

// ---------------- Server Utilization Email ---------------- //

export const EmailServerUtilizationReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`emailServerUtilization?location_id=${data.location_id}&deviceId=${data.deviceId}&fromDate=${data.fromDate}&toDate=${data.toDate}&branch_id=${data.branch_id}&facility_id=${data.facility_id}&building_id=${data.building_id}&floor_id=${data.floor_id}&lab_id=${data.lab_id}`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

// ---------------- Firmware Version Email ---------------- //

export const EmailFirmwareVersionReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`emailFirmwareVersion?location_id=${data.location_id}&deviceId=${data.deviceId}&fromDate=${data.fromDate}&toDate=${data.toDate}&branch_id=${data.branch_id}&facility_id=${data.facility_id}&building_id=${data.building_id}&floor_id=${data.floor_id}&lab_id=${data.lab_id}`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

// ---------------- Hardware Model Version Email ---------------- //

export const EmailHardwareVersionReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`emailHardwareVersionLog?location_id=${data.location_id}&deviceId=${data.deviceId}&fromDate=${data.fromDate}&toDate=${data.toDate}&branch_id=${data.branch_id}&facility_id=${data.facility_id}&building_id=${data.building_id}&floor_id=${data.floor_id}&lab_id=${data.lab_id}`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

// ---------------- Bumptest Email ---------------- //

export const EmailBumptestReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`emailBumpTest?location_id=${data.location_id}&deviceId=${data.device_id}&fromDate=${data.fromDate}&toDate=${data.toDate}&branch_id=${data.branch_id}&facility_id=${data.facility_id}&building_id=${data.building_id}&floor_id=${data.floor_id}&lab_id=${data.lab_id}`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

// ----------------Application Version Email ---------------- //

export const EmailAppVersionReportService = (successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`emailApplicationVersion`, 'GET', {}, successCallback, errorCallBack, '', 'email');
};

///----------------Complite Report----------------/////////

export const DispatchReportService = (data,successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`dispatch/${data.id}/download`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const DeliveryListReportService = (data,successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`deliveryList/${data.id}/download`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const SalePartListReportService = (data,successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`salePartList/${data.id}/download`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const DcListReportService = (data,successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`dcList/${data.id}/download`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};


export const InStockReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`incStock/${data.customerName}/${data.projectName}/download?fromDate=${data.fromDate}&toDate=${data.toDate}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};


export const ShortageReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`delShortage/${data.customerName}/${data.projectName}/download?fromDate=${data.fromDate}&toDate=${data.toDate}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const MonthReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`monthReport/${data.customerName}/${data.projectName}/download?month=${data.month}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};

export const StockOpnClsReportService = (data, successCallback, errorCallBack) => {
  return _fetchServiceDownloadCsvData(`stockOpnCls/${data.customerName}/${data.projectName}/download?fromDate=${data.fromDate}&toDate=${data.toDate}`, 'GET', {}, successCallback, errorCallBack, '', 'download');
};


